const base = {
    get() {
        return {
           /* url : "http://localhost:8082/cocal_dec/",
            name: "cocal_dec",
//            // 退出到首页链接
            indexUrl: 'http://localhost:8082/cocal_dec/front/index.html',
            fileUploadUrl: 'http://localhost:8082/cocal_dec/file/upload',*/
           /* url : "https://coal.tfwgkj.com:8082/cocal_dec/",
            name: "cocal_dec",
            // 退出到首页链接
            indexUrl: 'https://coal.tfwgkj.com:8082/cocal_dec/admin/dist/index.html',
            fileUploadUrl: 'https://coal.tfwgkj.com:8082/cocal_dec/file/upload'*/
            url : "http://www.mhykj.com/cocal_dec/",
            name: "cocal_dec",
            // 退出到首页链接
            indexUrl: 'http://www.mhykj.com/cocal_dec/front/index.html',
            fileUploadUrl: 'http://www.mhykj.com/cocal_dec/file/upload'

        };
    },
    getProjectName(){
        return {
            projectName: "AI配煤管理系统"
        } 
    }
}
export default base
